import React, { useEffect, useState } from 'react';
import './productDetails.css';
import ProductD from '../../assets/productD.png';
import ProductD1 from '../../assets/productD1.png';
import Veg from '../../assets/veg.png';
import DiscountLogo from '../../assets/discount-sale-svgrepo-com 2 (1).png'
import { useSwipeable } from 'react-swipeable'; 
import SimilarProducts from './similarProduct';
import Bottom from './Bottom';
/* import Procced from '../Procced/component'; */
import BackArrow from "../../../src/assets/backArrow.png"
import { useNavigate } from 'react-router-dom';
import ReplaceCard from '../../assets/ReplceCard.png'
import Procced from '../../ProccedToPay/component';
import ReplaceCartModal from '../../PopUp/ReplaceCartPopUp';
import DetailRow from "./listData.jsx"
const BASE_URL = "https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/"; // Replace with actual base URL if needed




const ImageCarousel1 = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handle swipe left and right using the useSwipeable hook
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length),
    onSwipedRight: () => setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1)),
    trackMouse: true // Optionally allow mouse swipe for desktop testing
  });

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="carousel" {...swipeHandlers}>
      {/* Image Display */}
      <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} />

      {/* Click Areas for Navigation */}
      <div className="nav-left" onClick={prevImage}></div>
      <div className="nav-right" onClick={nextImage}></div>

      {/* Dots Inside Image Box */}
      <div className="dots">
        {images.map((_, index) => (
          <span
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`dot ${index === currentIndex ? "active" : ""}`}
          ></span>
        ))}
      </div>
    </div>
  );
};















const ProductDetails = (props) => {

//console.log("props&&props.productDetailsData",props&&props.productDetailsData)
  const matchingData =
  props && props.cartItemsList && props.cartItemsList[0]
    ? props.cartItemsList
    : props.cartItemsList1;


    //console.log("matchingData",matchingData)


    const mergedData = props?.similarProduct?.map((item) => {
      const matchingItem = matchingData?.find(
        (matchItem) => matchItem.slotId === item.slot_id
      );
    
      //console.log("matchingItem-----", matchingItem?.count, item.mycount);
    
      return {
        ...item,
        mycount: matchingItem?.count ?? item.mycount,
      };
    }) || [];
    


//console.log("mergedData------->",mergedData)



  //console.log("tahzeeb Product Drtails------------------------>",props)
  const images = props&&props.imagePaths?.map((img) => (img.includes("http") ? img : `${BASE_URL}${img}`)) || [];
//console.log("++++++++++++++++++++++++++++++SimilarProducts",props&&props.productDetailsData&&props&&props.productDetailsData)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [infoHeight, setInfoHeight] = useState("193px");
    const [expanded, setExpanded] = useState(false);
    const [infoDivHeight, setInfoDivHeight] = useState("auto");
 const navigate=useNavigate()
    useEffect(() => {
      window.scrollTo(0,0)
      handleInfo()
        //console.log('Component mounted');
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                const newIndex = (prevIndex + 1) % images.length;
                //console.log(`Image changed to index: ${newIndex}`);
                return newIndex;
            });
        }, 3000);
        
        return () => {
            //console.log('Component unmounted, clearing interval');
            clearInterval(interval);
        };
    }, []);

    const handleInfo = () => {
        setExpanded(!expanded);
        setInfoHeight(expanded ? "193px" : "auto");

        if (!expanded) {
            setTimeout(() => {
                setInfoDivHeight("auto");
            }, 500); // Wait for the main info section to expand first
        } else {
            setInfoDivHeight("auto");
        }
    };

const handleback=(e)=>{
  const machineId=localStorage.getItem("machineId")
  navigate(`/items?machineId=${machineId}&showItems=true`)



}

  

    return (
      <>
       {props&&props.productDetailsData?.isSample==false&&(props&&props.countProduct)&&<Procced   preCart={props&&props.cartItemsList[0]&&props&&props.cartItemsList}    bottom={"110px"} totalAmount={props&&props.totalAmount}   productDetailsData={props&&props.productDetailsData} pdp={true}/>}
       
            {props && props.replaceCard && (
        <ReplaceCartModal setReplaceCard={props.setReplceCard} replaceMyCardFun={props&&props.replaceMyCard}/>
      
      )}
   
      
{/*       {(props&&props.countProduct)?<Procced bottom={"101px"} cartCount={props&&props.countProduct} totalamount={props&&props.totalAmount}/>:""} */}

<header className="header" style={{position: "fixed",width: "100%", top: "0", zIndex: "999"}}>
              <img src={BackArrow} style={{width:"20px"}} onClick={(e)=>{handleback(e)}}/>

                <h1 style={{marginLeft:"5vw",color: "#583C43","font-size": "18px"}}>{props&&props.productDetailsData&&props&&props.productDetailsData.productName}</h1>
            
            </header>
        <div className="container-product-detail" style={{    marginTop:"20vw"}}>
           
            
     <ImageCarousel1 images={images} SimilarProducts={props&&props.SimilarProducts}/>

       <DetailRow productDetailsData={props&&props.productDetailsData&&props&&props.productDetailsData}/>
            <SimilarProducts similarProduct={mergedData} AddIntoCart={props&&props.AddIntoCart} RemovefromCart={props&&props.RemovefromCart}/>
            <Bottom props={props} />

        </div>
        </>
    );
};

export default ProductDetails;

